module.exports = __webpack_public_path__ + "static/media/card-pack-sort.07409100.svg";